import { FC } from "react";

import { PrimaryText } from "@/components/Typography/Styled";

interface CoordinatesLinkProps {
    lat: number;
    lng: number;
}

export const CoordinatesLink: FC<CoordinatesLinkProps> = ({ lat, lng }) => {
    const href = `https://www.google.com/maps?q=${lat},${lng}`;

    return (
        <a href={href} target="_blank" rel="noreferrer">
            <PrimaryText ellipsis $textColor="accent">
                {`${lat.toFixed(6)}, ${lng.toFixed(6)}`}
            </PrimaryText>
        </a>
    );
};
